export default __webpack_public_path__ + "static/media/avatar_whitney1.5e8ed79c.mp3";